import {
  ROUTE_SECTION_EAT_FRESH,
  ROUTE_SECTION_STAY_ACTIVE,
  ROUTE_SECTION_BE_PRODUCTIVE,
  ROUTE_SECTION_EAT_FRESH_DEMO,
  ROUTE_SECTION_STAY_ACTIVE_DEMO,
  ROUTE_SECTION_BE_PRODUCTIVE_DEMO,
  ROUTE_SECTION_REST,
  ROUTE_HOME,
  ROUTE_MY_PROFILE,
  ROUTE_TRAIT_DETAILS,
  ROUTE_ONBOARDING,
  ROUTE_SECTION_MY_DNA_PROFILE,
} from 'routes';
import {
  beProductiveSectionTheme,
  eatFreshSectionTheme,
  restSectionTheme,
  stayActiveSectionTheme,
} from 'themes';
import {
  NavBeProductiveIcon,
  NavEatFreshIcon,
  NavStayActiveIcon,
  NavRestAndRejuvenateIcon,
  IconArrowRight,
  EatFreshBreakfast,
  EatFreshLunch,
  EatFreshDinner,
  EatFreshTips,
  EatFreshProfile,
  IconEatFresh,
  IconBeProductive,
  IconStayActive,
  IconRestAndRejuvenate,
  StayActiveMorning,
  StayActiveOffice,
  StayActiveWorkout,
  StayActiveTips,
  StayActiveProfile,
  BeProductiveTips,
  BeProductiveProfile,
  RestRejuvenateEvening,
  RestRejuvenateTips,
  MySkinProfile,
  MyAllergyProfile,
  MyHairProfile,
} from 'assets/iconsList';
import {
  BeProductiveBackground,
  EatFreshBackground,
  StayActiveBackground,
  RestAndRejuvenateBackground,
  BeProductiveSubHeaderBackground,
  EatFreshSubHeaderBackground,
  StayActiveSubHeaderBackground,
  RestAndRejuvenateSubHeaderBackground,
  MyDnaProfileBackground,
} from 'assets/imageList';

export const appStructure = {
  home: { route: ROUTE_HOME },
  myProfile: { route: ROUTE_MY_PROFILE },
  onboarding: { route: ROUTE_ONBOARDING },
  traitDetails: { route: ROUTE_TRAIT_DETAILS },
  demoMyBreakfast: { route: `${ROUTE_SECTION_EAT_FRESH}/demo/1` },
  demoMyLunch: { route: `${ROUTE_SECTION_EAT_FRESH}/demo/2` },
  demoMyDinner: { route: `${ROUTE_SECTION_EAT_FRESH}/demo/3` },
  sections: [
    {
      id: 0,
      name: 'My DNA Profile',
      translationKey: 'dna24.menu.myDnaProfile',
      route: ROUTE_SECTION_MY_DNA_PROFILE,
      theme: restSectionTheme,
      primaryIcon: NavRestAndRejuvenateIcon,
      secondaryIcon: IconArrowRight,
      tileBackgroundImage: MyDnaProfileBackground,
      subheaderBackgroundImage: RestAndRejuvenateSubHeaderBackground,
      subheaderIcon: IconRestAndRejuvenate,
      subsections: [
        {
          id: 0,
          name: 'My Nutrition Profile',
          translationKey: 'dna24.menu.nutritionProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/1`,
          icon: EatFreshProfile,
        },
        {
          id: 1,
          name: 'My Fitness Profile',
          translationKey: 'dna24.menu.stayActiveFitnessProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/2`,
          icon: StayActiveProfile,
        },
        {
          id: 2,
          name: 'My personality profile',
          translationKey: 'dna24.menu.beProductivePersonalityProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/3`,
          icon: BeProductiveProfile,
        },
        {
          id: 3,
          name: 'My Skin profile',
          translationKey: 'dna24.menu.mySkinProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/4`,
          icon: MySkinProfile,
        },
        {
          id: 4,
          name: 'My Allergy profile',
          translationKey: 'dna24.menu.myAllergyProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/5`,
          icon: MyAllergyProfile,
        },
        {
          id: 5,
          name: 'My Hair profile',
          translationKey: 'dna24.menu.myHairProfile',
          route: `${ROUTE_SECTION_MY_DNA_PROFILE}/6`,
          icon: MyHairProfile,
        },
      ],
    },
    {
      id: 1,
      name: 'Eat Fresh',
      translationKey: 'dna24.menu.nutrition',
      route: ROUTE_SECTION_EAT_FRESH,
      theme: eatFreshSectionTheme,
      primaryIcon: NavEatFreshIcon,
      secondaryIcon: IconArrowRight,
      tileBackgroundImage: EatFreshBackground,
      subheaderBackgroundImage: EatFreshSubHeaderBackground,
      subheaderIcon: IconEatFresh,
      subsections: [
        {
          id: 0,
          name: 'My Breakfast',
          translationKey: 'dna24.menu.nutritionBreakfast',
          route: `${ROUTE_SECTION_EAT_FRESH}/1`,
          icon: EatFreshBreakfast,
        },
        {
          id: 1,
          name: 'My Lunch',
          translationKey: 'dna24.menu.nutritionLunch',
          route: `${ROUTE_SECTION_EAT_FRESH}/2`,
          icon: EatFreshLunch,
        },
        {
          id: 2,
          name: 'My Dinner',
          translationKey: 'dna24.menu.nutritionDinner',
          route: `${ROUTE_SECTION_EAT_FRESH}/3`,
          icon: EatFreshDinner,
        },
        {
          id: 3,
          name: 'My Eating Tips',
          translationKey: 'dna24.menu.nutritionTips',
          route: `${ROUTE_SECTION_EAT_FRESH}/4`,
          icon: EatFreshTips,
        },
        {
          id: 4,
          name: 'My Nutrition Profile',
          translationKey: 'dna24.menu.nutritionProfile',
          route: `${ROUTE_SECTION_EAT_FRESH}/5`,
          icon: EatFreshProfile,
        },
      ],
    },
    {
      id: 2,
      name: 'Stay Active',
      translationKey: 'dna24.menu.stayActive',
      route: ROUTE_SECTION_STAY_ACTIVE,
      theme: stayActiveSectionTheme,
      primaryIcon: NavStayActiveIcon,
      secondaryIcon: IconArrowRight,
      tileBackgroundImage: StayActiveBackground,
      subheaderBackgroundImage: StayActiveSubHeaderBackground,
      subheaderIcon: IconStayActive,
      subsections: [
        {
          id: 0,
          name: 'My Morning Stretch',
          translationKey: 'dna24.menu.stayActiveMorningStretch',
          route: `${ROUTE_SECTION_STAY_ACTIVE}/1`,
          icon: StayActiveMorning,
        },
        {
          id: 1,
          name: 'My Office Stretch',
          translationKey: 'dna24.menu.stayActiveOfficeStretch',
          route: `${ROUTE_SECTION_STAY_ACTIVE}/2`,
          icon: StayActiveOffice,
        },
        {
          id: 2,
          name: 'My Workout Exercise',
          translationKey: 'dna24.menu.stayActiveWorkoutExercise',
          route: `${ROUTE_SECTION_STAY_ACTIVE}/3`,
          icon: StayActiveWorkout,
        },
        {
          id: 3,
          name: 'My Exercise Tips',
          translationKey: 'dna24.menu.stayActiveExerciseTips',
          route: `${ROUTE_SECTION_STAY_ACTIVE}/4`,
          icon: StayActiveTips,
        },
        {
          id: 4,
          name: 'My Fitness Profile',
          translationKey: 'dna24.menu.stayActiveFitnessProfile',
          route: `${ROUTE_SECTION_STAY_ACTIVE}/5`,
          icon: StayActiveProfile,
        },
      ],
    },
    {
      id: 3,
      name: 'Be Productive',
      translationKey: 'dna24.menu.beProductive',
      route: ROUTE_SECTION_BE_PRODUCTIVE,
      theme: beProductiveSectionTheme,
      primaryIcon: NavBeProductiveIcon,
      secondaryIcon: IconArrowRight,
      tileBackgroundImage: BeProductiveBackground,
      subheaderBackgroundImage: BeProductiveSubHeaderBackground,
      subheaderIcon: IconBeProductive,
      subsections: [
        // {
        //   id: 0,
        //   name: 'My Morning Personality',
        //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/1`,
        //   icon: BeProductiveMorning,
        // },
        // {
        //   id: 1,
        //   name: 'My Social Personality',
        //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/2`,
        //   icon: BeProductiveSocial,
        // },
        // {
        //   id: 2,
        //   name: 'My Work Personality',
        //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/3`,
        //   icon: BeProductiveWork,
        // },
        {
          id: 0,
          name: 'My Productivity Tips',
          translationKey: 'dna24.menu.beProductiveTips',
          route: `${ROUTE_SECTION_BE_PRODUCTIVE}/1`,
          icon: BeProductiveTips,
        },
        {
          id: 1,
          name: 'My Personality Profile',
          translationKey: 'dna24.menu.beProductivePersonalityProfile',
          route: `${ROUTE_SECTION_BE_PRODUCTIVE}/2`,
          icon: BeProductiveProfile,
        },
      ],
    },
    {
      id: 4,
      name: 'Rest & Rejuvenate',
      translationKey: 'dna24.menu.restRejuvenate',
      route: ROUTE_SECTION_REST,
      theme: restSectionTheme,
      primaryIcon: NavRestAndRejuvenateIcon,
      secondaryIcon: IconArrowRight,
      tileBackgroundImage: RestAndRejuvenateBackground,
      subheaderBackgroundImage: RestAndRejuvenateSubHeaderBackground,
      subheaderIcon: IconRestAndRejuvenate,
      subsections: [
        {
          id: 0,
          name: 'My Evening Stretch',
          translationKey: 'dna24.menu.restRejuvenateEveningStretch',
          route: `${ROUTE_SECTION_REST}/1`,
          icon: RestRejuvenateEvening,
        },
        // {
        //   id: 1,
        //   name: 'My Sleep Profile',
        //   route: `${ROUTE_SECTION_REST}/2`,
        //   icon: RestRejuvenateProfile,
        // },
        {
          id: 1,
          name: 'My Resting Tips',
          translationKey: 'dna24.menu.restRejuvenateTips',
          route: `${ROUTE_SECTION_REST}/2`,
          icon: RestRejuvenateTips,
        },
      ],
    },
  ],
};

const getSectionById = (sectionId) => {
  return appStructure.sections.find((section) => section.id === sectionId);
};

export const getCurrentSection = (location) => {
  return appStructure.sections.find((section) =>
    location.pathname.includes(section.route)
  );
};

export const getPreviousSection = (currentSectionId) => {
  let previousSection =
    currentSectionId === 0
      ? getSectionById(appStructure.sections.length - 1)
      : getSectionById(currentSectionId - 1);

  return previousSection;
};

export const getNextSection = (currentSectionId) => {
  let nextSection =
    currentSectionId === appStructure.sections.length - 1
      ? getSectionById(0)
      : getSectionById(currentSectionId + 1);

  return nextSection;
};

export const isCurrentSubsection = (location, subsection) => {
  return location.pathname.includes(subsection.route);
};

export const getCurrentSubsection = (location) => {
  const currentSection = getCurrentSection(location);

  let currentSubsection;
  if (currentSection) {
    currentSubsection = currentSection.subsections.find((subsection) =>
      location.pathname.includes(subsection.route)
    );
  }

  return currentSubsection;
};
